export const INCIDENT_LIST_ITEM_HEIGHT = 120
export const DATE_FILTERS_POPPER_DESKTOP_WIDTH = 600
export const STEPPER_HEIGHT = 76
export const MOBILE_FILTER_BUTTON_PADDING = 10